import {
  List,
  Datagrid,
  TextField,
  DateField,
  SelectInput,
  TextInput,
  FilterButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  SelectField,
  usePermissions,
  BulkDeleteButton,
  DateInput,
} from 'react-admin';

const gameTypeChoices = [
  { id: 'grid', name: 'Grid (2D)' },
  { id: 'grid_3d', name: 'Grid (3D)' },
  { id: 'higher_lower', name: 'Higher/Lower' },
  { id: 'timeline', name: 'Timeline' },
  { id: 'fact_or_cap', name: 'Fact or Cap' },
  { id: 'odd_one_out', name: 'Odd One Out' },
  { id: 'connections', name: 'Connections' },
  { id: 'guess_the_movie', name: 'Guess the Movie' },
  { id: 'redacted_plot', name: 'Redacted Plot' },
];

const entityTypeChoices = [
  { id: 'cricket_player', name: 'Cricket Player' },
  { id: 'movie', name: 'Movie' },
  { id: 'movie_song', name: 'Movie Song' },
];

const gameConfigFilters = [
  <SelectInput
    key="game_type"
    source="game_type"
    choices={gameTypeChoices}
    label="Game Type"
    alwaysOn
  />,
  <SelectInput
    key="entity_type"
    source="entity_type"
    choices={entityTypeChoices}
    label="Entity Type"
  />,
  <TextInput key="category" source="category" label="Category" />,
  <DateInput key="date_gte" source="date_gte" label="Date From" />,
  <DateInput key="date_lte" source="date_lte" label="Date To" />,
];

const ListActions = () => {
  const { permissions } = usePermissions();
  const canCreate =
    permissions?.role === 'super_admin' ||
    permissions?.permissions?.includes('game_configs:create');

  return (
    <TopToolbar>
      <FilterButton />
      {canCreate && <CreateButton />}
      <ExportButton />
    </TopToolbar>
  );
};

const BulkActionButtons = () => {
  const { permissions } = usePermissions();
  const canDelete =
    permissions?.role === 'super_admin' ||
    permissions?.permissions?.includes('game_configs:delete');

  return canDelete ? <BulkDeleteButton /> : null;
};

export const GameConfigList = () => (
  <List
    filters={gameConfigFilters}
    actions={<ListActions />}
    sort={{ field: 'date', order: 'DESC' }}
    perPage={25}
  >
    <Datagrid rowClick="edit" bulkActionButtons={<BulkActionButtons />}>
      <DateField source="date" label="Date" />
      <SelectField source="game_type" choices={gameTypeChoices} label="Game Type" />
      <SelectField source="entity_type" choices={entityTypeChoices} label="Entity Type" />
      <TextField source="category" label="Category" emptyText="-" />
      <TextField source="slug" label="Slug" />
      <DateField source="created_at" label="Created" showTime />
      <DateField source="updated_at" label="Updated" showTime />
    </Datagrid>
  </List>
);
